import { Card, CardContent, CardHeader, CardTitle } from '@folio/components';
import { Mail, Phone } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Group } from '@folio/components/ui/flex';

const contacts = [
  { label: 'Service courtier', phone: '+33 4 65 84 05 38' },
  { label: 'Gestion', email: 'gestion@tutassur.fr' },
  { label: 'Service production', email: 'prod@tutassur.fr' },
  { label: 'Service sinistre', email: 'sin@tutassur.fr' },
  { label: 'Service comptabilité', email: 'compta@tutassur.fr' },
  { label: 'Service partenariat', email: 'partenaires@tutassur.fr' },
];

export function ContactsUtiles() {
  const { t } = useTranslation();
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('sidebar.intermediary.contactsUtiles')}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid gap-3">
          {contacts.map(contact => (
            <Group key={contact.label} gap={3}>
              <div className="w-48 text-sm font-medium text-muted-foreground">{contact.label}</div>
              {contact.phone && (
                <a
                  href={`tel:${contact.phone}`}
                  className="flex items-center gap-1.5 text-sm hover:underline"
                >
                  <Phone className="h-4 w-4 shrink-0" />
                  {contact.phone}
                </a>
              )}
              {contact.email && (
                <a
                  href={`mailto:${contact.email}`}
                  className="flex items-center gap-1.5 text-sm hover:underline"
                >
                  <Mail className="h-4 w-4 shrink-0" />
                  {contact.email}
                </a>
              )}
            </Group>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
